import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { RUTAS } from 'const/Rutas';
import { useSubmitGrupos } from './useSubmitGrupos';
import { AlertaError } from 'utils/Alertas';
import { diccionarioVista } from '../utils/utils';

export const useHelpersGrupos = () => {
  const navigate = useHistory();
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});

  // PARA EL FUNCIONAMIENTO DEL MENSAJE DE CONFIRMACIÓN
  const handleClickOpen = (row, table) => {
    setSelectedRow(row);
    setOpen(true);
  };

  const handleClose = () => {
    setSelectedRow({});
    setOpen(false);
  };

  const { handleEliminarGrupo } = useSubmitGrupos();

  const handleClickIngresar = () => {
    navigate.push(`${RUTAS.ADMINISTRAR_GRUPOS_INGRESAR}`, {
      formulario: { tipo: 'ingresar' }
    });
  };

  const handleClickEditar = (row, table) => {
    const original = row.original;
    // Se verifica si original y original.codigoResiduo no son nulos ni indefinidos
    if (!original || !original.codigoGrupo) {
      // Si alguno de los dos es nulo o indefinido
      // se muestra un mensaje de error en la pantalla
      AlertaError(
        `Ha ocurrido un error al tratar de editar el ${diccionarioVista.primerNombrePrincipal}: no es un ${diccionarioVista.primerNombrePrincipal} válido.`
      );
      // Se devuelve el control inmediatamente y no se hace nada más
      return;
    }
    navigate.push(
      `${RUTAS.ADMINISTRAR_GRUPOS}/editar/${original.codigoGrupo}`,
      { formulario: { tipo: 'editar' } }
    );
  };

  const handleClickEliminar = (
    row,
    listaGrupos,
    setListaGrupos,
    setOpen,
    cargaGrupos
  ) => {
    const original = row.original;
    // Se verifica si original y original.codigoResiduo no son nulos ni indefinidos
    if (!original || !original.codigoGrupo) {
      // Si alguno de los dos es nulo o indefinido
      // se muestra un mensaje de error en la pantalla
      AlertaError(
        `Ha ocurrido un error al tratar de eliminar el ${diccionarioVista.primerNombrePrincipal}: no es un ${diccionarioVista.primerNombrePrincipal} válido.`
      );
      // Se devuelve el control inmediatamente y no se hace nada más
      return;
    }
    const codigoGrupo = original.codigoGrupo;
    // Hooks
    // console.log('Eliminar Perfil ::>', codigoPerfil);
    handleEliminarGrupo(codigoGrupo, cargaGrupos);
    setListaGrupos(listaGrupos.filter(r => r.codigoGrupo !== codigoGrupo));

    setOpen(false);
  };

  return {
    handleClickIngresar,
    handleClickEditar,
    handleClickEliminar,
    handleClickOpen,
    handleClose,
    setOpen,
    open,
    selectedRow
  };
};
